import { z } from "zod";
import { schemes } from "@zeal/common";

export const sendInvoiceEmailSchema = z.object({
  invoiceID: schemes.uuid(),
  companyID: schemes.companyID(),
  customerAccountID: schemes.uuid(),
});

export type TSendInvoiceEmailRequest = z.infer<typeof sendInvoiceEmailSchema>;

export const sendInvoiceEmailResponseSchema = z.object({
  success: z.boolean(),
  invoiceID: schemes.uuid(),
  email: z.string(),
});

export type TSendInvoiceEmailResponse = z.infer<
  typeof sendInvoiceEmailResponseSchema
>;
